import { Button, Form } from "antd";
import React from "react";
import styled from "styled-components/macro";
import { useTranslation } from "react-i18next";

import { useContextHospi } from "../../context/ContextHospi";
import { useHospiNavigate } from "../../utils/common";
import { SectionContainer } from "./StudentProfileEdit/styles";
import { SectionHeaderComponent } from "./StudentProfileEdit";
import { CHANGE_PASSWORD } from "../../utils/constants";

const FormRoot = styled(Form)`
  display: flex;
  flex-direction: row;
  gap: 40px;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const ChangePasswordButton = styled(Button)`
  margin-left: 16px;
`;

const EmailContainer = styled.div`
  @media (max-width: 460px) {
    width: 265px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const UserProfilePasswordSection = () => {
  const { cognitoUser } = useContextHospi();
  const navigate = useHospiNavigate();
  const { t } = useTranslation("profile");

  return (
    <SectionContainer>
      <SectionHeaderComponent
        showEditButton={false}
        title={t("passwordTitle")}
      />
      <FormRoot layout="vertical">
        <Form.Item label={t("email")}>
          <EmailContainer>{cognitoUser?.email}</EmailContainer>
        </Form.Item>
        <Form.Item label={t("password")}>
          ***********
          <ChangePasswordButton
            onClick={() => {
              navigate(CHANGE_PASSWORD);
            }}
          >
            {t("changePassword")}
          </ChangePasswordButton>
        </Form.Item>
      </FormRoot>
    </SectionContainer>
  );
};
